/* eslint-disable camelcase */
import React from 'react'
import { TableData } from 'contexts'
import { formatNullableBooleanAsYesNo } from 'utils/helpers/format'
import useGetCurrentVisibility from './useGetCurrentVisibility'
import useGenerateColumns from './useGenerateColumns'

type FormatProps = {
  title: string
}

const useDownLoadMaterialTable = ({ title }: FormatProps) => {
  // Manage title
  const currentDate = new Date().toLocaleDateString()
  const csvFileName = `VpAuto_Extranet_${currentDate}_${title}.csv`
  // Format CSV Data
  const { visibility } = useGetCurrentVisibility()
  const columns = useGenerateColumns()

  const formatCsvValue = React.useCallback(
    (columnId: keyof TableData, value: TableData[keyof TableData]) => {
      if (columnId === 'tvaRecuperable') {
        return formatNullableBooleanAsYesNo(value as boolean | null | undefined) ?? ' '
      }

      if (value === null || value === undefined || value === '') {
        return ' '
      }

      return value
    },
    [],
  )

  const generateCsv = React.useCallback(
    (data: Array<TableData>) => {
      const displayedColumns = columns
        .map((col) => {
          if (visibility[col.id as keyof typeof visibility] === true) {
            return col.header as string
          }
          return null
        })
        .filter((n) => n !== null)
        .join(';')

      const header = `\uFEFF ${displayedColumns} \n`

      const generateBodyLine = (dataLine: TableData) => {
        const bodyLine = columns
          .map((col) => {
            if (visibility[col.id as keyof typeof visibility] === false) {
              return null
            }
            return formatCsvValue(
              col.id as keyof TableData,
              dataLine[col.id as keyof typeof dataLine],
            )
          })
          .filter((n) => n !== null)
          .join(';')
        return bodyLine
      }

      const body = data.map((dataLine: TableData) => generateBodyLine(dataLine)).join('\n')

      return `${header}${body}`.replace(/(\d),(\d)/g, '$1$2')
    },
    [columns, formatCsvValue, visibility],
  )

  return { csvFileName, generateCsv }
}

export default useDownLoadMaterialTable
